import React from 'react'
import { Button, Input, Select, Table } from 'antd';
import { useAspirantes } from '../../hooks/adminexamen/useAspirantes';
import { EmptyPersonalizado } from '../../components/EmptyPersonalizado';
import { SearchOutlined, UserAddOutlined } from '@ant-design/icons';
import { buscar_cantidad_aspirantes } from '../../functions/arreglos';
import { Link } from 'react-router-dom';

export const Aspirantes = () => {

    const { columns, datosAspirantes, loading, setTextoBuscar, textoBuscar,
    ciclo, ciclosExamen, setCiclo } = useAspirantes()

    var cantidad_aspirantes = buscar_cantidad_aspirantes( datosAspirantes, false );

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'scroll'
        }}>

            <Link to="/registrar">
                <Button type="primary" icon={<UserAddOutlined />}>
                    Registrar aspirante
                </Button>
            </Link>


            <Select
                size="large"
                style={{
                    width: 200,
                    margin: '25px 0',
                }}
                onChange={ setCiclo }
                defaultValue={ ciclo }
            >
                <Select.Option value='todos'>
                    Mostrar todos
                </Select.Option>
                { ciclosExamen.map((e, i) =>{
                    return (
                        <Select.Option key={ i } value={ e.ciclo_examen }>
                            { e.ciclo_examen }
                        </Select.Option>
                    )}) }
            </Select>


            <Table
                columns = { columns }
                dataSource = { datosAspirantes }
                loading = { loading }
                rowKey = "pk_aspirante"
                showSorterTooltip = { false }
                locale = {{ emptyText: <EmptyPersonalizado/> }}
                title = { () => (
                    <>
                      <h1>{ cantidad_aspirantes }</h1>
                      <Input size='large' id='inputBuscarAspirante' autoComplete='off' placeholder="Buscar aspirante" allowClear onChange={ e => setTextoBuscar( e.target.value )  } value={ textoBuscar } prefix={ <SearchOutlined /> }/>
                    </>
                )}
            />
        </div>
    )
}
